import { IAccessItemsManager } from './IAccessItemsManager';
import { AccessItemModel } from "./AccessItemModel";
import { IFramework, IWebServiceManager, HttpMethod } from '@truckdown/framework';

class AccessItemsManager implements IAccessItemsManager {
    constructor(framework: IFramework) {
        this.manager = framework.getRequiredService<IWebServiceManager>('IWebServiceManager');
    }

    readonly manager: IWebServiceManager;

    get(): Promise<AccessItemModel[]> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/accessitems/get',
            method: HttpMethod.GET
        });

        return new Promise<AccessItemModel[]>((resolve, reject) => {
            this.manager
                .get<AccessItemModel[]>(request)
                .then((res) => {
                    resolve((res as AccessItemModel[]));
                })
                .catch((err) => {
                    console.log(err);
                    resolve([]);
                })
        });
    }

    add(accountId: string): Promise<AccessItemModel | null> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/accessitems/add/' + encodeURIComponent(accountId),
            method: HttpMethod.PUT
        });

        return new Promise<AccessItemModel | null>((resolve, reject) => {
            this.manager
                .get<AccessItemModel>(request)
                .then((res) => {
                    resolve((res as AccessItemModel));
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }

    addBookmark(accountId: string): Promise<AccessItemModel | null> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/accessitems/add-bookmark/' + encodeURIComponent(accountId),
            method: HttpMethod.PUT
        });

        return new Promise<AccessItemModel | null>((resolve, reject) => {
            this.manager
                .get<AccessItemModel>(request)
                .then((res) => {
                    resolve((res as AccessItemModel));
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }

    removeBookmark(accountId: string): Promise<AccessItemModel | null> {
        let request = this.manager.createRequest({
            service: this.manager.api,
            path: '/accounts/accessitems/remove-bookmark/' + encodeURIComponent(accountId),
            method: HttpMethod.DELETE
        });

        return new Promise<AccessItemModel | null>((resolve, reject) => {
            this.manager
                .get<AccessItemModel>(request)
                .then((res) => {
                    resolve((res as AccessItemModel));
                })
                .catch((err) => {
                    console.log(err);
                    resolve(null);
                })
        });
    }
}



export default (framework: IFramework) => {
    framework.registerTransient<IAccessItemsManager>('IAccessItemsManager', (frm) => {
        return new AccessItemsManager(frm);
    });
}